'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import UITag from 'UIComponents/tag/UITag';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { BY_PRODUCT as FEATURES_BY_PRODUCT } from 'ecosystem-marketplace-core/constants/groupTags/hubspotFeatures';
import * as HubSpotFeature from 'ecosystem-marketplace-core/constants/groupTags/HubSpotFeature';
import { getHubSpotFeatureI18nKey } from 'ecosystem-marketplace-core/utils/i18n';
import FilterTag from './FilterTag';
import { HUBSPOT_FEATURES } from '../../../constants/search/FilterKey';
const featuresMap = Immutable.OrderedMap({
  CRM: FEATURES_BY_PRODUCT.CRM,
  MARKETING: FEATURES_BY_PRODUCT.MARKETING,
  SALES: FEATURES_BY_PRODUCT.SALES,
  SERVICE: FEATURES_BY_PRODUCT.SERVICE,
  CMS: FEATURES_BY_PRODUCT.CMS,
  OPS: FEATURES_BY_PRODUCT.OPS
});

const HubSpotFeaturesGroup = ({
  groupKey,
  hubspotFeatures,
  getFilterLink,
  isPreview
}) => /*#__PURE__*/_jsxs(Fragment, {
  children: [/*#__PURE__*/_jsx("span", {
    className: "is--heading-7 m-top-2 m-bottom-2",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `ecosystemMarketplaceCore.groupTags.hubspotFeatureGroups.${groupKey}`
    })
  }), hubspotFeatures.map(hubspotFeature => [hubspotFeature, getHubSpotFeatureI18nKey(hubspotFeature)]).sortBy(([__, hubspotFeatureI18nKey]) => unescapedText(hubspotFeatureI18nKey)).map(([hubspotFeature, hubspotFeatureI18nKey]) => {
    return /*#__PURE__*/_jsx(UIRouterLink, {
      disabled: isPreview,
      to: getFilterLink(HUBSPOT_FEATURES, hubspotFeature, true),
      children: /*#__PURE__*/_jsx(FilterTag, {
        children: /*#__PURE__*/_jsx(UITag, {
          className: "m-left-0 m-right-3",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: hubspotFeatureI18nKey
          })
        })
      })
    }, hubspotFeature);
  }).toArray()]
});

const HubSpotFeatures = ({
  hubspotFeatures,
  getFilterLink,
  isPreview
}) => {
  const filteredFeatures = useMemo(() => featuresMap.map(allFeaturesForProduct => hubspotFeatures.filter(flatFeature => allFeaturesForProduct[flatFeature])).filter(features => !features.isEmpty()), [hubspotFeatures]);
  return /*#__PURE__*/_jsx(Fragment, {
    children: filteredFeatures.map((features, groupKey) => /*#__PURE__*/_jsx(HubSpotFeaturesGroup, {
      groupKey: groupKey,
      hubspotFeatures: features,
      getFilterLink: getFilterLink,
      isPreview: isPreview
    }, groupKey)).toArray()
  });
};

HubSpotFeatures.propTypes = {
  hubspotFeatures: ImmutablePropTypes.setOf(PropTypes.oneOf(Object.values(HubSpotFeature))).isRequired,
  getFilterLink: PropTypes.func.isRequired,
  isPreview: PropTypes.bool.isRequired
};
export default HubSpotFeatures;